import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

const Wrap = styled.footer`
    background: #39394C;
    height:267px;
    position: relative;
    @media screen and (max-width:700px) {
        height: 480px;
    }
`
const Wrapper = styled.div`
    margin: 0 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    padding-top: 1rem;
    @media screen and (max-width:700px)
    {
    flex-direction: column;
    align-items: flex-start;
    }
`
const NavLinks = styled.ul`
    display: flex;
    flex-direction: row;
    gap: 2rem;
    flex:1;
    justify-content: flex-end;
    @media screen and (max-width:700px) {
        flex-direction: column;
        margin-top: 3rem;
    }
`
const Nav = styled.li`
a{
    font-weight: 400;
font-size: 16px;
line-height: 20px;
/* identical to box height, or 125% */


/* White */

color: #FFFFFF;
}
   

`
const Email = styled.div`
    position: relative;
`
const EmailUs = styled.span`
    position: absolute;
    left: 0;
    bottom: 20px;
    margin: 0 40px;
    font-weight: 400;
font-size: 16px;
line-height: 20px;
/* identical to box height, or 125% */


/* White */

color: #FFFFFF;
`
interface FooterProps {

}

const Footer: React.FC<FooterProps> = ({}) => {
    let str = ""
    if (typeof window !== 'undefined')
    {
        let location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
    }
        return (
            <Wrap>
                <Wrapper>
                <Link to ='/'>
                <svg width="166" height="49" viewBox="0 0 166 49" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_712_55)">
<path d="M43.5234 27.8557H46.4192L50.8848 41.4212H50.9331L55.3987 27.8557H58.2955L52.3094 44.7563H49.5094L43.5234 27.8557Z" fill="white"/>
<path d="M61.6738 27.8557H64.4738V44.7563H61.6738V27.8557Z" fill="white"/>
<path d="M68.8203 42.2666V40.1419H71.5719V41.4254L72.4891 42.3426H77.7514L78.717 41.3771V38.2592L77.7751 37.3183H71.3577L68.8717 34.8559V30.342L71.3577 27.856H78.7921L81.2751 30.342V32.4904H78.5235V31.1871L77.5826 30.2699H72.5612L71.6203 31.1871V33.9871L72.5612 34.9043H78.9787L81.4647 37.3903V42.2182L78.9342 44.7566H71.3063L68.8203 42.2666Z" fill="white"/>
<path d="M85.6914 27.856H88.4904V44.7566H85.6914V27.856Z" fill="white"/>
<path d="M92.957 42.0247V30.5839L95.6849 27.856H104.037L106.764 30.5839V42.0247L104.037 44.7566H95.6849L92.957 42.0247ZM102.588 42.3387L103.964 40.9871V31.6255L102.588 30.2739H97.1333L95.758 31.6255V40.991L97.1333 42.3426L102.588 42.3387Z" fill="white"/>
<path d="M111.109 27.856H113.668L121.634 40.1419H121.682V27.856H124.362V44.7566H121.801L113.835 32.4943H113.787V44.7566H111.107L111.109 27.856Z" fill="white"/>
<path d="M133.631 27.856H136.286L142.393 44.7566H139.545L138.097 40.7491H131.797L130.348 44.7566H127.5L133.631 27.856ZM137.445 38.4043L134.959 31.2592H134.911L132.472 38.4043H137.445Z" fill="white"/>
<path d="M145.65 27.856H148.45V44.7566H145.65V27.856Z" fill="white"/>
<path d="M165.998 39.2978V44.7566H163.198V39.9731L161.46 38.0666H155.96V44.7566H153.16V27.856H163.443L165.901 30.342V35.5322L164.14 37.2936L165.998 39.2978ZM155.96 35.7494H162.18L163.146 34.7839V31.1871L162.18 30.2215H155.96V35.7494Z" fill="white"/>
<path d="M0 12.1033L5.13397 21.0019C20.8647 46.2482 45.2184 7.19249 48.519 0C48.5229 0 23.2519 40.511 0 12.1033Z" fill="#FF4C55"/>
<path d="M10.4102 30.3853L19.4242 45.9985C21.0039 48.7284 23.5808 48.7284 25.1565 45.9985L49.8252 3.26904C43.7099 11.1191 29.6922 40.7204 10.4102 30.3853Z" fill="#FF4C55"/>
</g>
<defs>
<clipPath id="clip0_712_55">
<rect width="166" height="48.0451" fill="white"/>
</clipPath>
</defs>
</svg>

    </Link>
                    <NavLinks>
                        {str == 'fr-fr'? 
                        <Nav><Link to='/fr-fr/a-propos'>A propos</Link></Nav>
                        :
                        <Nav><Link to='/about'>About us</Link></Nav>
                        }    
                       {str == 'fr-fr'? 
                        <Nav><Link to='/fr-fr/nos-services'>Nos services</Link></Nav>
                        :
                        <Nav><Link to='/services'>Services</Link></Nav>
                        } 
                        {str == 'fr-fr'? 
                        <Nav><Link to='/fr-fr/resource'>Nos projets</Link></Nav>
                        :
                        <Nav><Link to='/en-us/resource'>Our work</Link></Nav>
                        } 
                       {str == 'fr-fr'? 
                        <Nav><Link to='/fr-fr/nos-contacter'>Nos contacter</Link></Nav>
                        :
                        <Nav><Link to='/contact'>Contact us</Link></Nav>
                        } 
                    </NavLinks>

                </Wrapper>
                {str == 'fr-fr'? 
                <EmailUs>Envoyez-nous un courriel : contact@visionair.digital</EmailUs>
                :
                <EmailUs>Email us : contact@visionair.digital</EmailUs>
                }
                </Wrap>
        );
}
export default Footer